/* Black Forest: diagnostic events only; never completed purchases or customer data.
   Use the existing Clarity installation and respect Shopify processing permissions. */
(function () {
  'use strict';
  if (window.__bffClarityEventsV1) return;
  var shopify = window.Shopify;
  var theme = shopify && shopify.theme;
  if (shopify && (shopify.designMode || (theme && theme.role && theme.role !== 'main'))) return;
  window.__bffClarityEventsV1 = true;
  var productViewSent = false;
  var privacyLoadRequested = false;

  function send(name) {
    // Fail closed while the permission API is unavailable. Never infer consent from a loaded tag.
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') return false;
      if (privacy.analyticsProcessingAllowed() !== true || typeof window.clarity !== 'function') return false;
      window.clarity('event', name);
      return true;
    } catch (error) {
      // Only isolate this optional analytics call; do not suppress storefront errors.
      return false;
    }
  }

  // Added diagnostics use fixed event names only, at most once per page.
  // Never inspect or send form values, phone numbers, card messages or addresses.
  var diagnosticsSent = Object.create(null);
  var observedContainers = new WeakSet();

  function once(name) {
    if (diagnosticsSent[name]) return;
    if (send(name)) diagnosticsSent[name] = true;
  }

  function detailsContext(field) {
    if (!field || !field.closest) return null;
    var container = field.closest('[data-bff-delivery-fields]');
    var context = container && container.getAttribute('data-bff-context');
    return context === 'product' || context === 'cart' ? context : null;
  }

  function recordInvalid(field, nativeInvalid) {
    try {
      var context = detailsContext(field);
      if (!context || field.disabled || field.closest('[hidden]')) return;
      if (!nativeInvalid && field.getAttribute('aria-invalid') !== 'true') return;
      once('bff_' + context + '_details_error');
      if (field.hasAttribute('data-bff-date')) {
        once('bff_' + context + '_date_' + (field.validity && field.validity.valueMissing ? 'required' : 'unavailable'));
      }
      var wrap = field.closest('.bff-df__field');
      if (!wrap) return;
      ['sender', 'phone', 'recipient', 'date', 'time', 'card'].forEach(function (kind) {
        if (wrap.classList.contains('bff-df__field--' + kind)) {
          once('bff_' + context + '_details_error_' + kind);
        }
      });
    } catch (error) {
      // Isolate this optional diagnostic; never affect validation or ordering.
    }
  }

  function observeDetails() {
    if (typeof MutationObserver !== 'function') return;
    document.querySelectorAll('[data-bff-delivery-fields]').forEach(function (container) {
      if (observedContainers.has(container)) return;
      var observer = new MutationObserver(function (records) {
        records.forEach(function (record) { recordInvalid(record.target, false); });
      });
      observer.observe(container, {subtree: true, attributes: true, attributeFilter: ['aria-invalid']});
      observedContainers.add(container);
    });
  }

  document.addEventListener('input', function (event) {
    if (!event.isTrusted) return;
    var field = event.target;
    if (!field || !field.matches || !field.matches('input, textarea, select')) return;
    var context = detailsContext(field);
    if (context) once('bff_' + context + '_details_started');
  }, {passive: true});
  document.addEventListener('invalid', function (event) { recordInvalid(event.target, true); }, true);
  document.addEventListener('click', function (event) {
    if (event.isTrusted && event.target && event.target.closest && event.target.closest('a[href^="tel:"]')) {
      once('bff_phone_link_click');
    }
  }, {passive: true});

  document.addEventListener('bff:date:unavailable', function (event) {
    var detail = event.detail || {};
    if (detail.context !== 'product' && detail.context !== 'cart') return;
    once('bff_' + detail.context + '_date_reset_' + (detail.reason === 'sunday' ? 'sunday' : 'cutoff'));
  });
  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest && event.target.closest('.bff-local-product a[href], .m-search-result a[href*="/products/"]');
    if (link && event.isTrusted && send(link.closest('.bff-local-product') ? 'bff_local_product_click' : 'bff_search_product_click')) {
      try {
        var url = new URL(link.href, window.location.origin);
        var handle = /^\/products\/([a-z0-9-]+)\/?$/.exec(url.pathname);
        if (url.origin === window.location.origin && handle) window.clarity('set', 'bff_clicked_product', handle[1].slice(0, 100));
      } catch (error) {}
    }
  }, { passive: true });

  function productView() {
    if (document.visibilityState !== 'hidden' && document.body && document.body.classList.contains('template-cart')) {
      once('bff_cart_page_view');
    }
    if (productViewSent || document.visibilityState === 'hidden') return;
    if (!document.body || !document.body.hasAttribute('data-product-id')) return;
    productViewSent = send('bff_product_page_view');
    if (productViewSent) {
      try {
        var handle = /^\/products\/([a-z0-9-]+)\/?$/.exec(window.location.pathname);
        if (handle) window.clarity('set', 'bff_product', handle[1].slice(0, 100));
      } catch (error) {}
    }
  }

  function loadPrivacyApi() {
    var api = window.Shopify;
    if (!api || api.customerPrivacy || privacyLoadRequested || typeof api.loadFeatures !== 'function') return;
    privacyLoadRequested = true;
    try {
      api.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function (error) {
        if (!error) productView();
      });
    } catch (error) {
      // No consent changes, no analytics queue and no interruption to ordering.
    }
  }

  document.addEventListener('product-ajax:added', function (event) {
    var product = event.detail && event.detail.product;
    if (!product || product.status || !(Number(product.id || product.variant_id) > 0) || !(Number(product.quantity) > 0)) return;
    send('bff_add_to_cart_success');
  });
  document.addEventListener('product-ajax:error', function () { send('bff_add_to_cart_error'); });
  document.addEventListener('bff:extras:added', function () { send('bff_extras_added'); });
  document.addEventListener('bff:extras:error', function () { send('bff_extras_error'); });
  document.addEventListener('visitorConsentCollected', productView);
  document.addEventListener('visibilitychange', productView);
  window.addEventListener('pageshow', productView);

  function ready() {
    observeDetails();
    loadPrivacyApi();
    productView();
    // A finite set of retries accommodates the existing async tag without permanent polling.
    [500, 1000, 2000, 4000, 8000].forEach(function (delay) {
      window.setTimeout(function () { loadPrivacyApi(); productView(); }, delay);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, {once: true});
  else ready();
})();

